/* eslint-disable max-len */
import React from 'react';
import {
    ShimmerBadge,
    ShimmerTitle,
} from 'react-shimmer-effects';

export default function Shimmer() {
    return (
        <div className="mt-[30px]">
            {[...Array(4)].map((_, index) => (
                <div key={index} className="overflow-y-auto mb-[10px]">                    
                    <div className="flex rounded m-[1px] shadow-s7">                        
                        <div className="w-[100%] border shadow-s7 rounded border-[#e6e8ea] max-h-[200px]">
                            <div className="flex border-b h-10 items-center justify-between">
                                <div className="flex ml-[14px] mt-5">
                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                </div>
                                <div className="flex mr-[14px] mt-5">
                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                </div>
                            </div>
                            <div className="flex mt-[2px] mb-[2px]">
                                <div className="flex max-h-[113px]">
                                    <div class="flex items-center w-[10%] ml-[11px] mr-[20px]">
                                        <img src="/images/photo_uploaded.svg" alt="img" class="w-[96px] h-[96px] rounded border border-[#e7e7e7]" />
                                    </div>
                                    <div class="flex items-center w-[90%]">
                                        <div className="flex" >
                                            <div className="flex w-[100%]">
                                                <p
                                                    className="inline-grid ml-[20px] text-[#031624] leading-6 break-all min-w-[150px] 2xl:min-w-[120px] mt-2"
                                                    id="item_name"
                                                    data-testid={index + 'name'}
                                                >
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                </p>
                                                <p
                                                    className="inline-grid ml-[100px] text-[#031624] leading-6 break-all min-w-[150px] 2xl:min-w-[120px]  mt-2"
                                                    id="item_name"
                                                    data-testid={index + 'name'}
                                                >
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                </p>
                                                <p
                                                    className="inline-grid ml-[100px] text-[#031624] leading-6 break-all min-w-[150px] 2xl:min-w-[120px]  mt-2"
                                                    id="item_name"
                                                    data-testid={index + 'name'}
                                                >
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="w-[200px]"/>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
